import Dashboard from './Dashboard/containers/Dashboard';
import DashboardNotFound from './Dashboard/containers/DashboardNotFound';
import CspDetail from './Csp/containers/CspDetail';
import CspListing from './Csp/containers/CspListing';
import BrandDetail from './Brands/containers/BrandDetail';
import BrandsListing from './Brands/containers/BrandsListing';
import BrandSuspension from './Brands/containers/BrandSuspension';
import CampaignListingHU from './Campaigns/containers/CampaignListing/CampaignListingHU';
import CampaignListingUS from './Campaigns/containers/CampaignListing/CampaignListingUS';
import CampaignDetailsHU from '@/applications/MnoPortal/Campaigns/containers/CampaignDetails/CampaignDetailsHU';
import CampaignDetailsUS from '@/applications/MnoPortal/Campaigns/containers/CampaignDetails/CampaignDetailsUS';
import SenderIdsListing from '@/applications/MnoPortal/SenderIds/containers/SenderIdsListing';
import UniversalEinListing from './UniversalEin/containers/UniversalEinListing';
import Events from './Events/containers/Events';
import Integrations from './Integrations/containers/Integrations';
import { ProfilePage } from './Profile';
import { HeaderHoc, ErrorBoundaryHoc } from '../../hocs';
import PhoneHistory from './Phones/containers/PhoneHistory';
import SuspendedCampaigns from './Campaigns/containers/SuspendedCampaigns';
import AwaitingReviewCampaigns from './Campaigns/containers/AwaitingReviewCampaigns';
import RcsCampaigns from './Campaigns/containers/RcsCampaigns';
import RcsCampaignDetail from './Campaigns/containers/RcsCampaignDetail';
import CampaignRedirector from './Campaigns/containers/CampaignRedirector';
import { ROUTES } from '@/constants/paths';

export const mnoRoutes = [
  {
    path: '/dashboard',
    component: HeaderHoc(ErrorBoundaryHoc(Dashboard), {
      title: 'DASHBOARD',
    }),
    key: 'dashboard',
    countries: ['US'],
  },
  {
    path: '/dashboard/not-found',
    component: HeaderHoc(ErrorBoundaryHoc(DashboardNotFound), {
      title: '',
    }),
    key: 'dashboard-not-found',
    countries: ['US'],
  },
  {
    path: '/csp/:id',
    component: HeaderHoc(ErrorBoundaryHoc(CspDetail), { title: 'CSP PROFILE' }),
    key: 'csp-detail',
    countries: ['US'],
  },
  {
    path: '/csps',
    component: HeaderHoc(ErrorBoundaryHoc(CspListing), { title: 'CSPs' }),
    key: 'csp-listing',
    countries: ['US'],
  },
  {
    path: '/brands/:id',
    component: HeaderHoc(ErrorBoundaryHoc(BrandDetail), {
      title: 'BRAND DETAILS',
    }),
    key: 'brand-detail',
    countries: ['US', 'DE'],
  },
  {
    path: '/brands/',
    component: HeaderHoc(ErrorBoundaryHoc(BrandsListing), { title: 'BRANDS' }),
    key: 'brand-listing',
    countries: ['US', 'DE'],
  },
  {
    path: '/brand-suspension/:id',
    component: HeaderHoc(ErrorBoundaryHoc(BrandSuspension), {
      title: 'BRAND SUSPENSION',
    }),
    key: 'brand-suspension',
    countries: ['US', 'DE'],
  },
  {
    path: '/universal-ein/:id',
    component: HeaderHoc(ErrorBoundaryHoc(UniversalEinListing), {
      title: 'Universal EIN',
    }),
    key: 'universal-listing',
    countries: ['US'],
  },
  {
    path: '/universal-ein/:id/campaigns',
    component: HeaderHoc(ErrorBoundaryHoc(UniversalEinListing), {
      title: 'Universal EIN',
    }),
    key: 'universal-listing',
    countries: ['US'],
  },
  {
    path: '/universal-ein/:id/brands',
    component: HeaderHoc(ErrorBoundaryHoc(UniversalEinListing), {
      title: 'Universal EIN',
    }),
    key: 'universal-listing',
    countries: ['US'],
  },
  {
    path: '/phones/:phone',
    component: HeaderHoc(PhoneHistory, {
      title: 'Phone Number History',
    }),
    key: 'phone-history',
    countries: ['US'],
  },
  {
    path: ROUTES.TEN_DLC_CAMPAIGNS,
    component: HeaderHoc(CampaignListingUS, { title: '10DLC CAMPAIGNS' }),
    key: 'campaign-listing-us',
    countries: ['US'],
  },
  {
    path: ROUTES.PROGRAMS,
    component: HeaderHoc(CampaignListingHU),
    key: 'campaign-listing-hu',
    countries: ['HU'],
  },
  {
    path: ROUTES.PROGRAM_DETAILS,
    component: HeaderHoc(ErrorBoundaryHoc(CampaignDetailsHU)),
    key: 'campaign-listing-hu',
    countries: ['HU'],
  },
  {
    path: ROUTES.SENDER_IDS,
    component: HeaderHoc(ErrorBoundaryHoc(SenderIdsListing), {
      title: 'Sender ID Management',
    }),
    key: 'sender-id-listing',
    countries: ['HU'],
  },
  {
    path: '/review-campaigns',
    component: HeaderHoc(ErrorBoundaryHoc(AwaitingReviewCampaigns), {
      title: '10DLC CAMPAIGNS',
    }),
    key: 'review-campaigns-listing',
    countries: ['US'],
  },
  {
    path: '/suspended-campaigns',
    component: HeaderHoc(ErrorBoundaryHoc(SuspendedCampaigns), {
      title: 'Suspended 10DLC Campaigns',
    }),
    key: 'suspended-campaigns-listing',
    countries: ['US'],
  },
  {
    path: ROUTES.TEN_DLC_CAMPAIGN_DETAILS,
    component: HeaderHoc(ErrorBoundaryHoc(CampaignDetailsUS), {
      title: '10DLC CAMPAIGN',
    }),
    key: 'campaign-details-us',
    countries: ['US'],
  },
  {
    path: '/rcs-campaigns',
    component: HeaderHoc(ErrorBoundaryHoc(RcsCampaigns), {
      title: 'RCS Campaigns',
    }),
    key: 'rcs-campaign-listing',
    countries: ['US'],
    featureFlag: 'RCS_VISIBLE',
  },
  {
    path: '/rcs-campaigns/:id',
    component: HeaderHoc(ErrorBoundaryHoc(RcsCampaignDetail), {
      title: 'RCS Campaign',
    }),
    key: 'rcs-campaign-detail',
    countries: ['US'],
    featureFlag: 'RCS_CAMPAIGN',
  },
  {
    path: ROUTES.WILD_CARD_CAMPAIGN,
    component: HeaderHoc(ErrorBoundaryHoc(CampaignRedirector), {
      title: 'Campaign',
    }),
    key: 'campaign-redirector',
  },
  {
    path: '/events',
    component: HeaderHoc(ErrorBoundaryHoc(Events), { title: 'EVENTS' }),
    key: 'events-listing',
    countries: ['US', 'DE'],
  },
  {
    path: '/integrations',
    component: HeaderHoc(ErrorBoundaryHoc(Integrations), {
      title: 'INTEGRATIONS',
    }),
    key: 'integrations',
    countries: ['US'],
  },
  {
    path: '/profile',
    component: HeaderHoc(ErrorBoundaryHoc(ProfilePage), {
      title: 'MNO Profile',
    }),
    key: 'profile',
  },
];

export const getMnoRoutes = (props = {}) => {
  const { features = {}, country } = props;
  return mnoRoutes
    .filter((route) => {
      if (route.featureFlag) {
        return !!features[route.featureFlag];
      }
      return true;
    })
    .filter((route) => {
      return (
        !country ||
        !Array.isArray(route.countries) ||
        route.countries.includes(country)
      );
    });
};
